module.exports = __webpack_public_path__ + "img/css3.538c3d21.png";